import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_apex_web_persist_explicit_selection",
  stages: {
    affected_users: 1,
    main: 2,
    ddot: 3,
    mdot: 4,
    cfar: 5,
    flex: 6,
    insurance: 7,
    go_back: 8
  },
  goals: {},
  defaultStage: 1,
  goalsWithValue: []
});

const trackStages = (isMobile: boolean, hasCfar: boolean, hasFlex: boolean, hasInsurance: boolean) => {
  utils.stages.main();
  if (isMobile) utils.stages.mdot();
  if (!isMobile) utils.stages.ddot();
  if (hasCfar) utils.stages.cfar();
  if (hasInsurance) utils.stages.insurance();
  if (hasFlex) utils.stages.flex();
};

export default { ...utils, trackStages };
